import styled from "styled-components";
import { AddButton, ButtonRow, DeleteButton } from "../Components/FormComponents";

export const BackgroundPreview = styled.img`
  display: block;
  max-width: 100%;
  margin: 1.5em auto;
  border: 1px solid ${({ theme }) => theme.colors.lightgrey};
`;

export const DropDownImage = styled.button`
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.2rem dashed ${({ theme }) => theme.colors.buttonBlue};
  border-radius: 0.5rem;
  padding: 3rem 1rem;
  text-align: center;

  :hover {
    opacity: 0.7;
  }
`;

export const DropDownMessage = styled.span`
  color: ${({ theme }) => theme.colors.darkblue};
  font-size: 1.3rem;
`;

export const PreviewImageContainer = styled.div`
  width: 13rem;
`;

export const HandleImageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 1rem 0;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 33rem;
  }
`;

export const ErrorMsg = styled.div`
  margin: 0.5rem 0;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.darkred};
  color: ${({ theme }) => theme.colors.white};
  font-weight: bold;
`;

export const ButtonsRow = styled(ButtonRow)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    width: ${({ width }) => width}rem;
  }
`;

export const FixedAddButton = styled(AddButton)`
  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 12rem;
  }
`;

export const FixedDeleteButton = styled(DeleteButton)`
  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 22rem;
  }

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) => theme.colors.grey};
    opacity: 1;
  }
`;

export const allowedTypes = "image/gif,image/jpeg,image/jpg,image/png";
export const allowedTypesFormats = allowedTypes
  .split(",")
  .map(x => x.replace("image/", ""))
  .join(", ");
